module.exports = __webpack_public_path__ + "june-24-1.jpg?e3e684caa0f8e0778d5ed7cb5edb49f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/june-24-1.jpg
// module id = 216
// module chunks = 0